import { hasInLocalStorage } from '../../utils/localStorage';
export const selectIsChatspotEnabled = state => state.chatspotAuth.authInfo.currentHubHasChatSpotEnabled;
export const selectIsOnboardingComplete = state => {
  return state.chatspotAuth.authInfo.onboardingComplete || hasInLocalStorage('copilot:onboardingComplete');
};
export const selectUserAvatarUri = state => state.chatspotAuth.authInfo.userInfo.avatarUri;
export const selectChatspotUserInfo = state => state.chatspotAuth.authInfo.userInfo;
export const selectIsHipaaCoveredEntity = state => state.chatspotAuth.isHipaaCoveredEntity;